import { render, staticRenderFns } from "./MdtTextAccordion.vue?vue&type=template&id=7cc6e6e8&scoped=true"
import script from "./MdtTextAccordion.vue?vue&type=script&lang=js"
export * from "./MdtTextAccordion.vue?vue&type=script&lang=js"
import style0 from "./MdtTextAccordion.vue?vue&type=style&index=0&id=7cc6e6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc6e6e8",
  null
  
)

export default component.exports